// components/SideNavbar.js

import styles from '../../styles/SideNavbar.module.css';
import { useState } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { toggleTheme, MOON_PATH, SUN_PATH } from '../lib/theme';

const SideNavbar = ({isOpen, closeSidebar }) => {
    const router = useRouter();
    const { id } = router.query;
    const [isHovered, setIsHovered] = useState(false);
    const [isClicked, setClicked] = useState(false);
    


  const categories = [
    // Icons: /assets/sidenav/v2 — one set, 32x32 gradient tile + white glyph
    // Top group (divider after Glamzy Lookbook, see SideNavbar.module.css). `href` = a page outside /categories/
    { name: "Home", iconUrl: "/assets/sidenav/v2/home.svg", pageUrl: "/" },
    { name: "Recently Played", iconUrl: "/assets/sidenav/v2/recently-played.svg", pageUrl: "recently-played", href: "/recently-played" },
    { name: "New", iconUrl: "/assets/sidenav/v2/new-games.svg", pageUrl: "new-games" },
    { name: "Trending", iconUrl: "/assets/sidenav/v2/trending.svg", pageUrl: "trending-games" },
    { name: "Rising", iconUrl: "/assets/sidenav/v2/rising.svg", pageUrl: "rising-games" },
    { name: "Most Played", iconUrl: "/assets/sidenav/v2/most-played.svg", pageUrl: "popular-games" },
    { name: "Exclusive", iconUrl: "/assets/sidenav/v2/exclusive.svg", pageUrl: "exclusive-games" },
    { name: "Glamzy Lookbook", iconUrl: "/assets/sidenav/v2/fashion-library.svg", pageUrl: "glamzy", href: "/glamzy" },
    { name: "Christmas", iconUrl: "/assets/sidenav/v2/christmas.svg", pageUrl: "christmas-games" },
    { name: "Halloween", iconUrl: "/assets/sidenav/v2/halloween.svg", pageUrl: "halloween-games" },
    { name: "Princess", iconUrl: "/assets/sidenav/v2/princess.svg", pageUrl: "princess-games" },
    // { name: "Coloring Pages", iconUrl: "/assets/sidenav/coloring-pages.png", pageUrl: "coloring-pages" },
    { name: "Dress up", iconUrl: "/assets/sidenav/v2/dressup.svg", pageUrl: "dress-up-games" },
    { name: "Make Up", iconUrl: "/assets/sidenav/v2/makeup.svg", pageUrl: "makeover-games" },
    { name: "Decoration", iconUrl: "/assets/sidenav/v2/decoration.svg", pageUrl: "decoration-games" },
    { name: "Wedding", iconUrl: "/assets/sidenav/v2/wedding.svg", pageUrl: "wedding-games" },
    { name: "Celebrity", iconUrl: "/assets/sidenav/v2/celebrity.svg", pageUrl: "celebrity-games" },
    { name: "K-Pop", iconUrl: "/assets/sidenav/v2/kpop.svg", pageUrl: "kpop-dress-up-games" },
    { name: "Aesthetic", iconUrl: "/assets/sidenav/v2/aesthetic.svg", pageUrl: "aesthetic-dress-up-games" },
    { name: "Frozen", iconUrl: "/assets/sidenav/v2/frozen.svg", pageUrl: "frozen-games" },
    { name: "Monster High", iconUrl: "/assets/sidenav/v2/monster-high.svg", pageUrl: "monster-high-games" },
    { name: "Brainrot", iconUrl: "/assets/sidenav/v2/brainrot.svg", pageUrl: "brainrot-games" },
    { name: "Cooking", iconUrl: "/assets/sidenav/v2/cooking.svg", pageUrl: "cooking-games" },
    { name: "Doctor", iconUrl: "/assets/sidenav/v2/doctor.svg", pageUrl: "doctor-games" },
    { name: "FNF", iconUrl: "/assets/sidenav/v2/friday-night-funkin.svg", pageUrl: "friday-night-funkin" },
    // { name: "Prinxy Games", iconUrl: "/assets/sidenav/icons.png", pageUrl: "prinxy-games" },
    { name: "Winx club", iconUrl: "/assets/sidenav/v2/winx.svg", pageUrl: "winx-club-games" },
    // { name: "Girls Go Games", iconUrl: "/assets/sidenav/icons.png", pageUrl: "girlsgogames" },
    { name: "Shopaholic ", iconUrl: "/assets/sidenav/v2/shopaholic.svg", pageUrl: "shopaholic-games" },
    { name: "My Dolphin Show", iconUrl: "/assets/sidenav/v2/dolphin.svg", pageUrl: "my-dolphin-show" },
    { name: "View All Tag", iconUrl: "/assets/sidenav/v2/all-tag.svg", pageUrl: "all-categories" },
    // { name: "Blog", iconUrl: "/assets/sidenav/blogs.svg", pageUrl: "blog" },
    // { name: "Dl-Girls Games", iconUrl: "/assets/sidenav/icons.png", pageUrl: "dl-girls" },

    
  ];
 
//   console.log(`Current: ${router.pathname}, Category: ${category.name}, URL: ${category.pageUrl}, isActive: ${isActive}`);



const CurretnPath = () => {
  return `/categories/${{ id }.id}`;
};



return (


<>
      {(isOpen || isHovered) && <div className={styles.overlay} onClick={closeSidebar}></div>}
    <div data-area="side" className={`${styles.sideNavbar} ${isOpen ? styles.open : ''}`} style={{
      width:(isOpen || isHovered) ? '260px' : '0px', // Mobile handling
    }}
    onClick={closeSidebar}
      
        onMouseEnter={() => setIsHovered(true)}  // Show overlay on hover
        onMouseLeave={() => setIsHovered(false)} // Hide overlay when hover stops
    >
      <ul>
        {categories.map((category, index) => {
          const isActive = category.href ? router.pathname === category.href || router.pathname.startsWith(`${category.href}/`) : category.pageUrl === "/" ? router.pathname === "/" :CurretnPath() === `/categories/${category.pageUrl}`;
          const isAlltag = category.pageUrl === "all-categories" ? router.pathname === "/all-categories" :CurretnPath() === `/categories/${category.pageUrl}`;
          const isBlog = category.pageUrl === "blog" ? router.pathname === "/blog" :CurretnPath() === `/categories/${category.pageUrl}`;
          const isColoringpage = category.pageUrl === "coloring-pages" ? router.pathname === "/coloring-pages" :CurretnPath() === `/coloring-pages/${category.pageUrl}`;
           

          return (
            <li
            
              key={index}
              title={category.name}
              className={`${styles.categoryItem} ${isActive ? styles.active : ''} ${isAlltag ? styles.active : ''} ${isBlog ? styles.active : ''} ${isColoringpage ? styles.active : ''}`}
              onClick={() => {
                {isOpen && setIsHovered(false)}
                {!isOpen && setClicked(true)}
                router.push(category.href ? category.href : category.pageUrl === "/" ? "/" : category.pageUrl === "coloring-pages" ? "/coloring-pages" : category.pageUrl === "all-categories" ? "/all-categories" : category.pageUrl === "blog" ? "/blog" :`/categories/${category.pageUrl}`)}}>
              <Image src={category.iconUrl} alt={category.name} className={`${styles.icon} unset_position`} fill/>
              <span className={styles.categoryName}>{category.name}</span>
            </li>
          );
        })}
        {/* light / dark theme switch: phones only (desktop has it in the header) */}
        <li className={`${styles.categoryItem} ${styles.themeItem}`} onClick={toggleTheme}>
          <svg className={`${styles.icon} ${styles.moonIcon}`} aria-hidden="true" viewBox="0 0 24 24" fill="currentColor"><path d={MOON_PATH} /></svg>
          <svg className={`${styles.icon} ${styles.sunIcon}`} aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><path d={SUN_PATH} /></svg>
          <span className={`${styles.categoryName} ${styles.darkLabel}`}>Dark mode</span>
          <span className={`${styles.categoryName} ${styles.lightLabel}`}>Light mode</span>
        </li>
      </ul>
    </div>
    </>
  );
};

export default SideNavbar;
